var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement, nothing } from 'lit';
import { property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { appendStylesToTheStyleRoot } from '../utilities/dom';
import stylesGlobal from './_sds-file-upload-global.lit.scss';
import styles from './sds-file-upload.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
import { repeat } from 'lit/directives/repeat.js';
import './sds-file-upload-item.lit';
import { when } from 'lit/directives/when.js';
import { getDictionary } from '@synisys/dictionary';
import { DisplayMode } from './types/display-mode';
import { translate } from '../utilities/translate';
import { Task } from '@lit/task';
import { cropImage } from './utils/image-crop-utils';
import '../button/upload/sds-upload-button.lit';
/**
 * Control that represents a file-upload component.
 *
 */
let SdsFileUpload = (() => {
    var _SdsFileUpload__fileInfoList_accessor_storage, _SdsFileUpload__isDragOver_accessor_storage, _SdsFileUpload__showFileMaxCountValidation_accessor_storage, _SdsFileUpload__showFileTotalMaxSizeValidation_accessor_storage, _SdsFileUpload__showMaxFileSizePerFileValidation_accessor_storage, _SdsFileUpload__showFileTypeValidation_accessor_storage, _SdsFileUpload__singleImageProgress_accessor_storage, _SdsFileUpload__popupStatusMessage_accessor_storage, _SdsFileUpload__filesInUploadingProcess_accessor_storage, _SdsFileUpload__isErrorsVisible_accessor_storage, _SdsFileUpload__progressByFileMapping_accessor_storage, _SdsFileUpload__canUploadNewFiles_accessor_storage, _SdsFileUpload_width_accessor_storage, _SdsFileUpload_height_accessor_storage, _SdsFileUpload_maxFileCount_accessor_storage, _SdsFileUpload_maxFileSizePerFile_accessor_storage, _SdsFileUpload_maxTotalFileSize_accessor_storage, _SdsFileUpload_allowedFileTypes_accessor_storage, _SdsFileUpload_displayMode_accessor_storage, _SdsFileUpload_disabled_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-file-upload')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let __fileInfoList_decorators;
    let __fileInfoList_initializers = [];
    let __fileInfoList_extraInitializers = [];
    let __isDragOver_decorators;
    let __isDragOver_initializers = [];
    let __isDragOver_extraInitializers = [];
    let __showFileMaxCountValidation_decorators;
    let __showFileMaxCountValidation_initializers = [];
    let __showFileMaxCountValidation_extraInitializers = [];
    let __showFileTotalMaxSizeValidation_decorators;
    let __showFileTotalMaxSizeValidation_initializers = [];
    let __showFileTotalMaxSizeValidation_extraInitializers = [];
    let __showMaxFileSizePerFileValidation_decorators;
    let __showMaxFileSizePerFileValidation_initializers = [];
    let __showMaxFileSizePerFileValidation_extraInitializers = [];
    let __showFileTypeValidation_decorators;
    let __showFileTypeValidation_initializers = [];
    let __showFileTypeValidation_extraInitializers = [];
    let __singleImageProgress_decorators;
    let __singleImageProgress_initializers = [];
    let __singleImageProgress_extraInitializers = [];
    let __popupStatusMessage_decorators;
    let __popupStatusMessage_initializers = [];
    let __popupStatusMessage_extraInitializers = [];
    let __filesInUploadingProcess_decorators;
    let __filesInUploadingProcess_initializers = [];
    let __filesInUploadingProcess_extraInitializers = [];
    let __isErrorsVisible_decorators;
    let __isErrorsVisible_initializers = [];
    let __isErrorsVisible_extraInitializers = [];
    let __progressByFileMapping_decorators;
    let __progressByFileMapping_initializers = [];
    let __progressByFileMapping_extraInitializers = [];
    let __canUploadNewFiles_decorators;
    let __canUploadNewFiles_initializers = [];
    let __canUploadNewFiles_extraInitializers = [];
    let _width_decorators;
    let _width_initializers = [];
    let _width_extraInitializers = [];
    let _height_decorators;
    let _height_initializers = [];
    let _height_extraInitializers = [];
    let _maxFileCount_decorators;
    let _maxFileCount_initializers = [];
    let _maxFileCount_extraInitializers = [];
    let _maxFileSizePerFile_decorators;
    let _maxFileSizePerFile_initializers = [];
    let _maxFileSizePerFile_extraInitializers = [];
    let _maxTotalFileSize_decorators;
    let _maxTotalFileSize_initializers = [];
    let _maxTotalFileSize_extraInitializers = [];
    let _allowedFileTypes_decorators;
    let _allowedFileTypes_initializers = [];
    let _allowedFileTypes_extraInitializers = [];
    let _displayMode_decorators;
    let _displayMode_initializers = [];
    let _displayMode_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    var SdsFileUpload = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            this._stylesGlobal = stylesGlobal;
            _SdsFileUpload__fileInfoList_accessor_storage.set(this, __runInitializers(this, __fileInfoList_initializers, []));
            _SdsFileUpload__isDragOver_accessor_storage.set(this, (__runInitializers(this, __fileInfoList_extraInitializers), __runInitializers(this, __isDragOver_initializers, false)));
            _SdsFileUpload__showFileMaxCountValidation_accessor_storage.set(this, (__runInitializers(this, __isDragOver_extraInitializers), __runInitializers(this, __showFileMaxCountValidation_initializers, false)));
            _SdsFileUpload__showFileTotalMaxSizeValidation_accessor_storage.set(this, (__runInitializers(this, __showFileMaxCountValidation_extraInitializers), __runInitializers(this, __showFileTotalMaxSizeValidation_initializers, false)));
            _SdsFileUpload__showMaxFileSizePerFileValidation_accessor_storage.set(this, (__runInitializers(this, __showFileTotalMaxSizeValidation_extraInitializers), __runInitializers(this, __showMaxFileSizePerFileValidation_initializers, false)));
            _SdsFileUpload__showFileTypeValidation_accessor_storage.set(this, (__runInitializers(this, __showMaxFileSizePerFileValidation_extraInitializers), __runInitializers(this, __showFileTypeValidation_initializers, false)));
            _SdsFileUpload__singleImageProgress_accessor_storage.set(this, (__runInitializers(this, __showFileTypeValidation_extraInitializers), __runInitializers(this, __singleImageProgress_initializers, void 0)));
            _SdsFileUpload__popupStatusMessage_accessor_storage.set(this, (__runInitializers(this, __singleImageProgress_extraInitializers), __runInitializers(this, __popupStatusMessage_initializers, void 0)));
            _SdsFileUpload__filesInUploadingProcess_accessor_storage.set(this, (__runInitializers(this, __popupStatusMessage_extraInitializers), __runInitializers(this, __filesInUploadingProcess_initializers, [])));
            _SdsFileUpload__isErrorsVisible_accessor_storage.set(this, (__runInitializers(this, __filesInUploadingProcess_extraInitializers), __runInitializers(this, __isErrorsVisible_initializers, false)));
            _SdsFileUpload__progressByFileMapping_accessor_storage.set(this, (__runInitializers(this, __isErrorsVisible_extraInitializers), __runInitializers(this, __progressByFileMapping_initializers, new Map())));
            _SdsFileUpload__canUploadNewFiles_accessor_storage.set(this, (__runInitializers(this, __progressByFileMapping_extraInitializers), __runInitializers(this, __canUploadNewFiles_initializers, true)));
            _SdsFileUpload_width_accessor_storage.set(this, (__runInitializers(this, __canUploadNewFiles_extraInitializers), __runInitializers(this, _width_initializers, '100%')));
            _SdsFileUpload_height_accessor_storage.set(this, (__runInitializers(this, _width_extraInitializers), __runInitializers(this, _height_initializers, '100%')));
            _SdsFileUpload_maxFileCount_accessor_storage.set(this, (__runInitializers(this, _height_extraInitializers), __runInitializers(this, _maxFileCount_initializers, 10)));
            _SdsFileUpload_maxFileSizePerFile_accessor_storage.set(this, (__runInitializers(this, _maxFileCount_extraInitializers), __runInitializers(this, _maxFileSizePerFile_initializers, void 0)));
            _SdsFileUpload_maxTotalFileSize_accessor_storage.set(this, (__runInitializers(this, _maxFileSizePerFile_extraInitializers), __runInitializers(this, _maxTotalFileSize_initializers, void 0)));
            _SdsFileUpload_allowedFileTypes_accessor_storage.set(this, (__runInitializers(this, _maxTotalFileSize_extraInitializers), __runInitializers(this, _allowedFileTypes_initializers, void 0)));
            _SdsFileUpload_displayMode_accessor_storage.set(this, (__runInitializers(this, _allowedFileTypes_extraInitializers), __runInitializers(this, _displayMode_initializers, DisplayMode.DRAG_ABLE_CARD)));
            _SdsFileUpload_disabled_accessor_storage.set(this, (__runInitializers(this, _displayMode_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            this._imageCroppingTask = (__runInitializers(this, _disabled_extraInitializers), new Task(this, {
                args: () => {
                    var _a;
                    return [
                        (_a = this._fileInfoList[0]) === null || _a === void 0 ? void 0 : _a.file,
                        this._convertToPixels(this.width),
                        this._convertToPixels(this.height),
                    ];
                },
                task: async ([file, cropWidth, cropHeight]) => {
                    return cropImage(file, cropWidth, cropHeight);
                },
            }));
        }
        /**
         * Maintains the current list of files uploaded or selected by the user.
         *
         * This is a reactive property marked with the `@state` decorator, ensuring that any changes
         * to the list automatically trigger re-renders of the component, particularly the list
         * of uploaded files rendered by `_renderFiles`.
         *
         * - Each item in the list is of type `FileInfo`, representing metadata about the file.
         * - The `FileInfo` structure typically includes:
         *    - `file`: A `File` object containing the actual file data.
         *    - `isValid`: A boolean indicating whether the file passed validation checks.
         *    - `validationMessageKeys`: An array of validation message keys for localized error handling.
         *
         * This property is used to:
         * - Display the current list of uploaded files to the user.
         * - Support operations like adding new files, removing files, and performing validations.
         *
         * Usage in the component:
         * - Files are added via `_addNewFiles` when selected through the upload button or dropped into the drag-and-drop area.
         * - Files are removed via `_handleFileDelete`, which filters out the corresponding file from `_fileInfoList`.
         * - Changes to `_fileInfoList` are reflected in the rendered file list using the Lit `repeat` directive.
         *
         * Note: This property is private and managed internally by the component. External interactions
         * should be handled through public methods or events.
         **/
        get _fileInfoList() { return __classPrivateFieldGet(this, _SdsFileUpload__fileInfoList_accessor_storage, "f"); }
        set _fileInfoList(value) { __classPrivateFieldSet(this, _SdsFileUpload__fileInfoList_accessor_storage, value, "f"); }
        get _isDragOver() { return __classPrivateFieldGet(this, _SdsFileUpload__isDragOver_accessor_storage, "f"); }
        set _isDragOver(value) { __classPrivateFieldSet(this, _SdsFileUpload__isDragOver_accessor_storage, value, "f"); }
        get _showFileMaxCountValidation() { return __classPrivateFieldGet(this, _SdsFileUpload__showFileMaxCountValidation_accessor_storage, "f"); }
        set _showFileMaxCountValidation(value) { __classPrivateFieldSet(this, _SdsFileUpload__showFileMaxCountValidation_accessor_storage, value, "f"); }
        get _showFileTotalMaxSizeValidation() { return __classPrivateFieldGet(this, _SdsFileUpload__showFileTotalMaxSizeValidation_accessor_storage, "f"); }
        set _showFileTotalMaxSizeValidation(value) { __classPrivateFieldSet(this, _SdsFileUpload__showFileTotalMaxSizeValidation_accessor_storage, value, "f"); }
        get _showMaxFileSizePerFileValidation() { return __classPrivateFieldGet(this, _SdsFileUpload__showMaxFileSizePerFileValidation_accessor_storage, "f"); }
        set _showMaxFileSizePerFileValidation(value) { __classPrivateFieldSet(this, _SdsFileUpload__showMaxFileSizePerFileValidation_accessor_storage, value, "f"); }
        get _showFileTypeValidation() { return __classPrivateFieldGet(this, _SdsFileUpload__showFileTypeValidation_accessor_storage, "f"); }
        set _showFileTypeValidation(value) { __classPrivateFieldSet(this, _SdsFileUpload__showFileTypeValidation_accessor_storage, value, "f"); }
        get _singleImageProgress() { return __classPrivateFieldGet(this, _SdsFileUpload__singleImageProgress_accessor_storage, "f"); }
        set _singleImageProgress(value) { __classPrivateFieldSet(this, _SdsFileUpload__singleImageProgress_accessor_storage, value, "f"); }
        get _popupStatusMessage() { return __classPrivateFieldGet(this, _SdsFileUpload__popupStatusMessage_accessor_storage, "f"); }
        set _popupStatusMessage(value) { __classPrivateFieldSet(this, _SdsFileUpload__popupStatusMessage_accessor_storage, value, "f"); }
        get _filesInUploadingProcess() { return __classPrivateFieldGet(this, _SdsFileUpload__filesInUploadingProcess_accessor_storage, "f"); }
        set _filesInUploadingProcess(value) { __classPrivateFieldSet(this, _SdsFileUpload__filesInUploadingProcess_accessor_storage, value, "f"); }
        get _isErrorsVisible() { return __classPrivateFieldGet(this, _SdsFileUpload__isErrorsVisible_accessor_storage, "f"); }
        set _isErrorsVisible(value) { __classPrivateFieldSet(this, _SdsFileUpload__isErrorsVisible_accessor_storage, value, "f"); }
        get _progressByFileMapping() { return __classPrivateFieldGet(this, _SdsFileUpload__progressByFileMapping_accessor_storage, "f"); }
        set _progressByFileMapping(value) { __classPrivateFieldSet(this, _SdsFileUpload__progressByFileMapping_accessor_storage, value, "f"); }
        get _canUploadNewFiles() { return __classPrivateFieldGet(this, _SdsFileUpload__canUploadNewFiles_accessor_storage, "f"); }
        set _canUploadNewFiles(value) { __classPrivateFieldSet(this, _SdsFileUpload__canUploadNewFiles_accessor_storage, value, "f"); }
        /**
         * Sets the width of the file upload component, allowing the component to
         * adjust its width based on user interface requirements.
         *
         * @attr {number} width - The width of the file upload component in pixels.
         */
        get width() { return __classPrivateFieldGet(this, _SdsFileUpload_width_accessor_storage, "f"); }
        set width(value) { __classPrivateFieldSet(this, _SdsFileUpload_width_accessor_storage, value, "f"); }
        /**
         * Sets the minimum height of the file upload component, allowing the component to
         * adjust its height based on user interface requirements.
         *
         * @attr {number} height - The minimum height of the file upload component in pixels.
         */
        get height() { return __classPrivateFieldGet(this, _SdsFileUpload_height_accessor_storage, "f"); }
        set height(value) { __classPrivateFieldSet(this, _SdsFileUpload_height_accessor_storage, value, "f"); }
        /**
         * The `maxFileCount` property defines the maximum number of files that can be selected in the file upload input.
         * This property is exposed as the `max-file-count` attribute on the custom element.
         *
         * - `@property({ type: Number, attribute: 'max-file-count' })`:
         *    - This decorator links the property to the HTML attribute `max-file-count`.
         *    - The `type: Number` ensures that the property is treated as a number both in JavaScript and when reflected from the HTML attribute.
         *    - The `attribute: 'max-file-count'` option ensures that the property is bound to the corresponding HTML attribute, allowing it to be set in the HTML markup.
         *
         */
        get maxFileCount() { return __classPrivateFieldGet(this, _SdsFileUpload_maxFileCount_accessor_storage, "f"); }
        set maxFileCount(value) { __classPrivateFieldSet(this, _SdsFileUpload_maxFileCount_accessor_storage, value, "f"); }
        /**
         * Maximum file size allowed per file in KB.
         */
        get maxFileSizePerFile() { return __classPrivateFieldGet(this, _SdsFileUpload_maxFileSizePerFile_accessor_storage, "f"); }
        set maxFileSizePerFile(value) { __classPrivateFieldSet(this, _SdsFileUpload_maxFileSizePerFile_accessor_storage, value, "f"); }
        /**
         * Maximum total size allowed for all attached files in MB.
         */
        get maxTotalFileSize() { return __classPrivateFieldGet(this, _SdsFileUpload_maxTotalFileSize_accessor_storage, "f"); }
        set maxTotalFileSize(value) { __classPrivateFieldSet(this, _SdsFileUpload_maxTotalFileSize_accessor_storage, value, "f"); }
        /**
         * Specifies the allowed file extensions for the file input.
         * This should be an array of file extensions (e.g., ["png", "jpeg", "pdf"]).
         * The file input will only accept files with these extensions.
         *
         * @type {string[]}
         */
        get allowedFileTypes() { return __classPrivateFieldGet(this, _SdsFileUpload_allowedFileTypes_accessor_storage, "f"); }
        set allowedFileTypes(value) { __classPrivateFieldSet(this, _SdsFileUpload_allowedFileTypes_accessor_storage, value, "f"); }
        /**
         * Determines the display style of the file upload control.
         * - `UPLOAD_BUTTON`: Shows a button to trigger file upload.
         * - `DRAG_ABLE_CARD`: Shows a drag-and-drop enabled card.
         *
         * @type {DisplayMode}
         * @default DisplayMode.DRAG_ABLE_CARD
         */
        get displayMode() { return __classPrivateFieldGet(this, _SdsFileUpload_displayMode_accessor_storage, "f"); }
        set displayMode(value) { __classPrivateFieldSet(this, _SdsFileUpload_displayMode_accessor_storage, value, "f"); }
        /**
         * Disables the file upload component.
         *
         * @type {boolean}
         * @default false
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsFileUpload_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsFileUpload_disabled_accessor_storage, value, "f"); }
        connectedCallback() {
            super.connectedCallback();
            this._listenProgressDataEvent();
            this._listenFileUploadedEvent();
        }
        disconnectedCallback() {
            this._resetInnerState();
            super.disconnectedCallback();
        }
        _resetInnerState() {
            this._fileInfoList = [];
            this._isDragOver = false;
            this._showFileMaxCountValidation = false;
            this._showFileTotalMaxSizeValidation = false;
            this._showMaxFileSizePerFileValidation = false;
            this._showFileTypeValidation = false;
            this._singleImageProgress = null;
            this._popupStatusMessage = null;
            this._filesInUploadingProcess = [];
            this._isErrorsVisible = false;
            this._progressByFileMapping = new Map();
            this.disabled = false;
        }
        _listenProgressDataEvent() {
            this.addEventListener(SdsFileUpload.FILE_PROGRESS_DATA_EVENT, (event) => {
                const fileProgress = event.detail;
                if (fileProgress.done) {
                    this._filesInUploadingProcess = this._filesInUploadingProcess.filter(f => f !== event.detail.file);
                }
                else {
                    this._filesInUploadingProcess.push(event.detail.file);
                }
                this._progressByFileMapping = new Map(this._progressByFileMapping);
                this._progressByFileMapping.set(fileProgress.file, fileProgress);
                if (this._showSingleImageCard() &&
                    fileProgress.file === this._fileInfoList[0].file) {
                    this._singleImageProgress = fileProgress;
                }
            });
        }
        _listenFileUploadedEvent() {
            this.addEventListener(SdsFileUpload.FILE_UPLOADED_EVENT, (event) => {
                const file = event.detail;
                let counter = 1;
                const intervalId = setInterval(() => {
                    this.dispatchEvent(new CustomEvent(SdsFileUpload.FILE_PROGRESS_DATA_EVENT, {
                        detail: {
                            file: file,
                            percent: counter * 10,
                            done: counter === 10,
                        },
                    }));
                    counter++;
                    if (counter > 10) {
                        clearInterval(intervalId);
                    }
                }, 10);
            });
        }
        _convertToPixels(value) {
            if (value.endsWith('%')) {
                const percentage = parseFloat(value);
                const parentElement = this.parentElement;
                if (!parentElement) {
                    return 0;
                }
                const parentWidth = parentElement.offsetWidth;
                return (parentWidth * percentage) / 100;
            }
            if (value.endsWith('px')) {
                return parseFloat(value);
            }
            const numValue = parseFloat(value);
            return isNaN(numValue) ? 0 : numValue;
        }
        firstUpdated() {
            if (this.displayMode !== DisplayMode.UPLOAD_BUTTON) {
                this.style.width = `${this.width}`;
                this.style.minHeight = `${this.height}`;
                if (this.height.endsWith('%')) {
                    this.style.height = `${this.height}`;
                }
            }
        }
        render() {
            appendStylesToTheStyleRoot(this, 'sds-file-upload', this._stylesGlobal.cssText);
            return html `
            ${this._renderFileUploadAccessibilityDescription()}
            ${when(this._showSingleImageCard(), () => this._renderSingleImageCard(), () => html `${when(this._canUploadNewFiles, () => when(this.displayMode === DisplayMode.DRAG_ABLE_CARD, () => this._renderDragAbleCard(), () => this._renderUploadButton()), () => nothing)}
                ${this._renderFiles()}`)}
            ${when(this._isErrorsVisible, () => this._renderErrors(), () => nothing)}
        `;
        }
        _renderFileUploadAccessibilityDescription() {
            return html ` <div aria-live="polite" aria-atomic="true" class="sr-only">
                ${this._popupStatusMessage || nothing}
            </div>
            <div id="file-upload-description" class="sr-only">
                You are currently on a File Upload Component. Drop your files here, or use the
                browse button to upload files.
                ${when(this.maxFileCount, () => html `Up to ${this.maxFileCount.toString()} files.`, () => nothing)}
                ${when(this.maxTotalFileSize, () => html `Each up to ${this.maxTotalFileSize.toString()} KB.`, () => nothing)}
                Supported formats: ${this.allowedFileTypes.map(c => c.toUpperCase()).join(', ')}.
            </div>`;
        }
        _renderDragAbleCard() {
            return html ` <div
            @dragover="${(e) => {
                e.preventDefault();
                this._isDragOver = true;
            }}"
            @drop="${(event) => {
                this._handleDrop(event);
            }}"
            @dragleave="${(event) => {
                event.preventDefault();
                this._isDragOver = false;
            }}"
            class="${this._getClasses()}"
            style="width: ${this.width}; min-height: ${this.height};"
            role="group"
            aria-labelledby="file-upload-description"
            aria-disabled="${this.disabled ? 'true' : 'false'}"
            tabindex="${this.disabled ? '-1' : '0'}"
        >
            <div class="sds-file-upload__wrapper">
                ${this._renderUploadIcon()}
                <div class="sds-file-upload__content">
                    ${translate('sds.file_upload.drag_able_card_placeholder')}
                    <sds-button-upload
                        multiple
                        label="${translate('sds.file_upload.drag_able_card_browse_link_title')}"
                        type="tertiary"
                        size="sm"
                        accept="${this._getFileAcceptAttribute()}"
                        ?disabled="${this.disabled}"
                        role="group"
                        aria-label="Browse button to select files."
                        @sds.files.selected="${(event) => {
                this._handleNewFilesSelection(event);
            }}"
                    ></sds-button-upload>
                </div>
            </div>
            <div class="sds-file-upload__footer">
                ${when(this.maxFileCount > 1, () => html `${this.maxFileSizePerFile
                ? getDictionary()
                    .translate('sds.file_upload.drag_able_card_file_count_size_info')
                    .replace('%count', this.maxFileCount.toString())
                    .replace('%size', this.maxFileSizePerFile.toString())
                : getDictionary()
                    .translate('sds.file_upload.drag_able_card_file_count_info_unlimited')
                    .replace('%count', this.maxFileCount.toString())}`, () => when(this.maxFileSizePerFile, () => html `${getDictionary()
                .translate('sds.file_upload.drag_able_card_single_file_info')
                .replace('%size', this.maxFileSizePerFile.toString())}`, () => nothing))}
                ${when(this.allowedFileTypes, () => {
                var _a;
                return html `${(_a = (this.allowedFileTypes.length == 1
                    ? getDictionary().translate('sds.file_upload.drag_able_card_single_file_format_info')
                    : getDictionary().translate('sds.file_upload.drag_able_card_file_format_info'))) === null || _a === void 0 ? void 0 : _a.replace('%s', this.allowedFileTypes.map(c => c.toUpperCase()).join(', '))}`;
            }, () => nothing)}
            </div>
        </div>`;
        }
        _renderSingleImageCard() {
            return html ` <div
            class="${this._getClasses()}"
            style="width: ${this.width}; min-height: ${this.height};"
        >
            ${when(!this._singleImageProgress || !this._singleImageProgress.done, () => {
                var _a;
                return html `
                    <div
                        class="sds-file-upload__wrapper"
                        role="status"
                        aria-live="polite"
                        aria-atomic="true"
                    >
                        <div>
                            ${translate('sds.file_upload.uploading')}<span aria-hidden="true"
                                >...</span
                            >
                        </div>
                        <sds-progress-bar
                            size="lg"
                            percent="${this._singleImageProgress
                    ? (_a = this._singleImageProgress) === null || _a === void 0 ? void 0 : _a.percent
                    : 0}%"
                            aria-hidden="true"
                        ></sds-progress-bar>
                    </div>
                `;
            }, () => html `
                    <div class="sr-only" role="status" aria-live="polite" aria-atomic="true">
                        ${getDictionary().translate('sds.file_upload.uploaded_successfully')}
                    </div>
                    ${this._imageCroppingTask.render({
                complete: (croppedFile) => {
                    return html `
                                ${when(this._singleImageProgress.done, () => html `
                                        <img
                                            aria-hidden="true"
                                            width="${this.width}"
                                            height="${this.height}"
                                            src="${URL.createObjectURL(croppedFile)}"
                                            alt="${this._fileInfoList[0].file.name}"
                                        />
                                    `, () => nothing)}
                            `;
                },
            })}
                `)}
            <sds-button
                type="primary"
                size="md"
                icon="delete"
                @click="${() => {
                this._fileInfoList = [];
                this._singleImageProgress = null;
                this._canUploadNewFiles = true;
            }}"
                class="sds-file-upload__delete-button"
                role="group"
                aria-label="Delete ${this._fileInfoList[0].file.name}"
            ></sds-button>
        </div>`;
        }
        _renderUploadButton() {
            return html `
            <sds-button-upload
                icon="upload"
                multiple
                label="${translate('sds.file_upload.upload_document_button_title')}"
                type="primary"
                size="lg"
                ?disabled="${this.disabled}"
                accept="${this._getFileAcceptAttribute()}"
                @sds.files.selected="${(event) => {
                this._handleNewFilesSelection(event);
            }}"
            ></sds-button-upload>
        `;
        }
        _renderFiles() {
            return html `
            ${when(this._fileInfoList.length > 0, () => html ` <div class="sds-uploaded-files-container" style="width: ${this.width};">
                    ${repeat(this._fileInfoList, (fileInfo) => { var _a; return (_a = this._progressByFileMapping.get(fileInfo.file)) === null || _a === void 0 ? void 0 : _a.percent; }, (fileInfo) => html `
                                <sds-file-upload-item
                                    .fileInfo="${fileInfo}"
                                    .fileProgress="${this._progressByFileMapping.get(fileInfo.file)}"
                                    max-file-size="${this.maxFileSizePerFile}"
                                    @sds.upload.file.delete="${(event) => {
                this._handleFileDelete(event);
            }}"
                                ></sds-file-upload-item>
                            `)}
                </div>`, () => nothing)}
        `;
        }
        _renderErrors() {
            return html `
            ${when(this._showFileMaxCountValidation, () => html ` <sds-info-snippet
                    class="sds-file-upload-error"
                    type="error"
                    role="status"
                    aria-live="polite"
                    aria-atomic="true"
                >
                    ${getDictionary()
                .translate('sds.file_upload.file_max_count_validation')
                .replace('%s', this.maxFileCount.toString())}
                </sds-info-snippet>`, () => nothing)}
            ${when(this._showFileTotalMaxSizeValidation, () => html ` <sds-info-snippet
                    class="sds-file-upload-error"
                    type="error"
                    role="status"
                    aria-live="polite"
                    aria-atomic="true"
                >
                    ${getDictionary()
                .translate('sds.file_upload.files_max_size_validation')
                .replace('%s', this.maxTotalFileSize.toString())}
                </sds-info-snippet>`, () => nothing)}
            ${when(this._showMaxFileSizePerFileValidation, () => html ` <sds-info-snippet
                    class="sds-file-upload-error"
                    type="error"
                    role="status"
                    aria-live="polite"
                    aria-atomic="true"
                >
                    ${getDictionary()
                .translate('sds.file_upload.file_max_size_validation')
                .replace('%s', this.maxFileSizePerFile.toString())}
                </sds-info-snippet>`, () => nothing)}
            ${when(this._showFileTypeValidation, () => html ` <sds-info-snippet
                    class="sds-file-upload-error"
                    type="error"
                    role="status"
                    aria-live="polite"
                    aria-atomic="true"
                >
                    ${getDictionary()
                .translate('sds.file_upload.file_type_validation')
                .replace('%s', this.allowedFileTypes.map(c => c.toUpperCase()).join(', '))}
                </sds-info-snippet>`, () => nothing)}
        `;
        }
        _renderUploadIcon() {
            return html `
            <div class="sds-file-upload__icon" aria-hidden="true">
                <svg
                    width="20"
                    height="25"
                    viewBox="0 0 20 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        id="Arrow"
                        d="M19.4564 9.83832L11.4564 1.33832C10.6667 0.499291 9.33328 0.499292 8.5436 1.33832L0.543606 9.83832C-0.213427 10.6427 -0.175071 11.9084 0.629276 12.6654C1.43362 13.4225 2.69937 13.3841 3.45641 12.5798L8 7.75221V22.209C8 23.3136 8.89543 24.209 10 24.209C11.1046 24.209 12 23.3136 12 22.209V7.7522L16.5436 12.5798C17.3006 13.3841 18.5664 13.4225 19.3707 12.6654C20.1751 11.9084 20.2134 10.6427 19.4564 9.83832Z"
                        fill="white"
                    />
                </svg>
            </div>
        `;
        }
        _handleNewFilesSelection(event) {
            this._addNewFiles(event.detail.files);
            this._hideErrors();
        }
        _handleDrop(event) {
            event.preventDefault();
            this._isDragOver = false;
            if (event.dataTransfer) {
                this._addNewFiles(Array.from(event.dataTransfer.files));
                this._hideErrors();
            }
        }
        _addNewFiles(files) {
            this._showFileMaxCountValidation = this._totalFilesCount(files) > this.maxFileCount;
            const totalFilesSize = this._totalFilesSize(files);
            this._showFileTotalMaxSizeValidation =
                !!this.maxTotalFileSize && totalFilesSize > this.maxTotalFileSize;
            this._showMaxFileSizePerFileValidation =
                this.maxFileCount === 1 &&
                    files.length === 1 &&
                    !!this.maxFileSizePerFile &&
                    files[0].size > this.maxFileSizePerFile * 1024;
            this._showFileTypeValidation = !this._isFileTypesValid(files);
            if (this._showFileMaxCountValidation ||
                this._showFileTotalMaxSizeValidation ||
                this._showFileTypeValidation ||
                this._showMaxFileSizePerFileValidation) {
                this._isErrorsVisible = true;
                return;
            }
            const newFileInfoList = files.map((file) => {
                return {
                    file: file,
                    isValid: !this.maxFileSizePerFile || file.size <= this.maxFileSizePerFile * 1024,
                    validationMessageKeys: !this.maxFileSizePerFile || file.size > this.maxFileSizePerFile * 1024
                        ? ['sds.file_upload.file_max_size_validation']
                        : [],
                };
            });
            this._fileInfoList = [...this._fileInfoList, ...newFileInfoList];
            this._canUploadNewFiles =
                this._fileInfoList.length < this.maxFileCount &&
                    (!this.maxTotalFileSize || totalFilesSize < this.maxTotalFileSize);
            this._showPopupStatusMessage(files);
            this.dispatchEvent(new CustomEvent(SdsFileUpload.NEW_FILES_ADDED_EVENT, {
                detail: { fileInfoList: newFileInfoList },
            }));
            newFileInfoList.forEach((fileInfo) => {
                this.dispatchEvent(new CustomEvent(SdsFileUpload.FILE_PROGRESS_DATA_EVENT, {
                    detail: {
                        file: fileInfo.file,
                        percent: 0,
                        done: false,
                    },
                }));
            });
        }
        _handleFileDelete(event) {
            this._fileInfoList = this._fileInfoList.filter((fileInfo) => fileInfo.file !== event.detail.file);
            this.dispatchEvent(new CustomEvent(event.type, { detail: event.detail }));
            this._canUploadNewFiles =
                this._fileInfoList.length < this.maxFileCount &&
                    (!this.maxTotalFileSize || this._totalFilesSize([]) < this.maxTotalFileSize);
        }
        _getFileAcceptAttribute() {
            if (this.allowedFileTypes) {
                return this.allowedFileTypes.map((fileType) => `.${fileType}`).join(',');
            }
            return '';
        }
        _getFileType(file) {
            const match = file.name.match(/\.([a-zA-Z0-9]+)$/);
            return match ? match[1].toLowerCase() : '';
        }
        _getClasses() {
            return classMap({
                'sds-file-upload': true,
                'sds-file-upload--uploaded': this._showSingleImageCard() && this._singleImageProgress.done,
                'sds-file-upload--focused': this._isDragOver,
                'sds-file-upload--uploading': this._filesInUploadingProcess.length > 0,
                'sds-file-upload--disabled': this.disabled,
                'sds-file-upload--only-single-img': this._showSingleImageCard(),
            });
        }
        _totalFilesSize(newFiles) {
            const newFileSize = newFiles.reduce((acc, file) => acc + file.size, 0);
            const existingFileSize = this._fileInfoList.reduce((acc, fileInfo) => acc + fileInfo.file.size, 0);
            return (newFileSize + existingFileSize) / 1024 / 1024;
        }
        _totalFilesCount(newFiles) {
            return newFiles.length + this._fileInfoList.length;
        }
        _isFileTypesValid(newFiles) {
            const fileTypes = newFiles.map((file) => {
                return this._getFileType(file);
            });
            return (!this.allowedFileTypes ||
                fileTypes.every((fileType) => {
                    return this.allowedFileTypes.includes(fileType);
                }));
        }
        _showPopupStatusMessage(files) {
            if (files.length) {
                this._popupStatusMessage = `Uploading files: ${files
                    .map(f => f.name)
                    .join(', ')}. Progress popup is now visible.`;
                setTimeout(() => {
                    this._popupStatusMessage = null;
                    this.requestUpdate();
                }, 10000);
            }
        }
        _showSingleImageCard() {
            return (this.maxFileCount === 1 &&
                this._fileInfoList.length === 1 &&
                this._fileInfoList[0].file.type.includes('image'));
        }
        _hideErrors() {
            setTimeout(() => {
                this._isErrorsVisible = false;
                this.requestUpdate();
            }, 3000);
        }
    };
    _SdsFileUpload__fileInfoList_accessor_storage = new WeakMap();
    _SdsFileUpload__isDragOver_accessor_storage = new WeakMap();
    _SdsFileUpload__showFileMaxCountValidation_accessor_storage = new WeakMap();
    _SdsFileUpload__showFileTotalMaxSizeValidation_accessor_storage = new WeakMap();
    _SdsFileUpload__showMaxFileSizePerFileValidation_accessor_storage = new WeakMap();
    _SdsFileUpload__showFileTypeValidation_accessor_storage = new WeakMap();
    _SdsFileUpload__singleImageProgress_accessor_storage = new WeakMap();
    _SdsFileUpload__popupStatusMessage_accessor_storage = new WeakMap();
    _SdsFileUpload__filesInUploadingProcess_accessor_storage = new WeakMap();
    _SdsFileUpload__isErrorsVisible_accessor_storage = new WeakMap();
    _SdsFileUpload__progressByFileMapping_accessor_storage = new WeakMap();
    _SdsFileUpload__canUploadNewFiles_accessor_storage = new WeakMap();
    _SdsFileUpload_width_accessor_storage = new WeakMap();
    _SdsFileUpload_height_accessor_storage = new WeakMap();
    _SdsFileUpload_maxFileCount_accessor_storage = new WeakMap();
    _SdsFileUpload_maxFileSizePerFile_accessor_storage = new WeakMap();
    _SdsFileUpload_maxTotalFileSize_accessor_storage = new WeakMap();
    _SdsFileUpload_allowedFileTypes_accessor_storage = new WeakMap();
    _SdsFileUpload_displayMode_accessor_storage = new WeakMap();
    _SdsFileUpload_disabled_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsFileUpload");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __fileInfoList_decorators = [state()];
        __isDragOver_decorators = [state()];
        __showFileMaxCountValidation_decorators = [state()];
        __showFileTotalMaxSizeValidation_decorators = [state()];
        __showMaxFileSizePerFileValidation_decorators = [state()];
        __showFileTypeValidation_decorators = [state()];
        __singleImageProgress_decorators = [state()];
        __popupStatusMessage_decorators = [state()];
        __filesInUploadingProcess_decorators = [state()];
        __isErrorsVisible_decorators = [state()];
        __progressByFileMapping_decorators = [state()];
        __canUploadNewFiles_decorators = [state()];
        _width_decorators = [property({ type: String })];
        _height_decorators = [property({ type: String, attribute: 'height' })];
        _maxFileCount_decorators = [property({ type: Number, attribute: 'max-file-count' })];
        _maxFileSizePerFile_decorators = [property({ type: Number, attribute: 'max-file-size-per-file' })];
        _maxTotalFileSize_decorators = [property({ type: Number, attribute: 'max-total-file-size' })];
        _allowedFileTypes_decorators = [property({ type: Array })];
        _displayMode_decorators = [property({ type: String })];
        _disabled_decorators = [property({ type: Boolean })];
        __esDecorate(_classThis, null, __fileInfoList_decorators, { kind: "accessor", name: "_fileInfoList", static: false, private: false, access: { has: obj => "_fileInfoList" in obj, get: obj => obj._fileInfoList, set: (obj, value) => { obj._fileInfoList = value; } }, metadata: _metadata }, __fileInfoList_initializers, __fileInfoList_extraInitializers);
        __esDecorate(_classThis, null, __isDragOver_decorators, { kind: "accessor", name: "_isDragOver", static: false, private: false, access: { has: obj => "_isDragOver" in obj, get: obj => obj._isDragOver, set: (obj, value) => { obj._isDragOver = value; } }, metadata: _metadata }, __isDragOver_initializers, __isDragOver_extraInitializers);
        __esDecorate(_classThis, null, __showFileMaxCountValidation_decorators, { kind: "accessor", name: "_showFileMaxCountValidation", static: false, private: false, access: { has: obj => "_showFileMaxCountValidation" in obj, get: obj => obj._showFileMaxCountValidation, set: (obj, value) => { obj._showFileMaxCountValidation = value; } }, metadata: _metadata }, __showFileMaxCountValidation_initializers, __showFileMaxCountValidation_extraInitializers);
        __esDecorate(_classThis, null, __showFileTotalMaxSizeValidation_decorators, { kind: "accessor", name: "_showFileTotalMaxSizeValidation", static: false, private: false, access: { has: obj => "_showFileTotalMaxSizeValidation" in obj, get: obj => obj._showFileTotalMaxSizeValidation, set: (obj, value) => { obj._showFileTotalMaxSizeValidation = value; } }, metadata: _metadata }, __showFileTotalMaxSizeValidation_initializers, __showFileTotalMaxSizeValidation_extraInitializers);
        __esDecorate(_classThis, null, __showMaxFileSizePerFileValidation_decorators, { kind: "accessor", name: "_showMaxFileSizePerFileValidation", static: false, private: false, access: { has: obj => "_showMaxFileSizePerFileValidation" in obj, get: obj => obj._showMaxFileSizePerFileValidation, set: (obj, value) => { obj._showMaxFileSizePerFileValidation = value; } }, metadata: _metadata }, __showMaxFileSizePerFileValidation_initializers, __showMaxFileSizePerFileValidation_extraInitializers);
        __esDecorate(_classThis, null, __showFileTypeValidation_decorators, { kind: "accessor", name: "_showFileTypeValidation", static: false, private: false, access: { has: obj => "_showFileTypeValidation" in obj, get: obj => obj._showFileTypeValidation, set: (obj, value) => { obj._showFileTypeValidation = value; } }, metadata: _metadata }, __showFileTypeValidation_initializers, __showFileTypeValidation_extraInitializers);
        __esDecorate(_classThis, null, __singleImageProgress_decorators, { kind: "accessor", name: "_singleImageProgress", static: false, private: false, access: { has: obj => "_singleImageProgress" in obj, get: obj => obj._singleImageProgress, set: (obj, value) => { obj._singleImageProgress = value; } }, metadata: _metadata }, __singleImageProgress_initializers, __singleImageProgress_extraInitializers);
        __esDecorate(_classThis, null, __popupStatusMessage_decorators, { kind: "accessor", name: "_popupStatusMessage", static: false, private: false, access: { has: obj => "_popupStatusMessage" in obj, get: obj => obj._popupStatusMessage, set: (obj, value) => { obj._popupStatusMessage = value; } }, metadata: _metadata }, __popupStatusMessage_initializers, __popupStatusMessage_extraInitializers);
        __esDecorate(_classThis, null, __filesInUploadingProcess_decorators, { kind: "accessor", name: "_filesInUploadingProcess", static: false, private: false, access: { has: obj => "_filesInUploadingProcess" in obj, get: obj => obj._filesInUploadingProcess, set: (obj, value) => { obj._filesInUploadingProcess = value; } }, metadata: _metadata }, __filesInUploadingProcess_initializers, __filesInUploadingProcess_extraInitializers);
        __esDecorate(_classThis, null, __isErrorsVisible_decorators, { kind: "accessor", name: "_isErrorsVisible", static: false, private: false, access: { has: obj => "_isErrorsVisible" in obj, get: obj => obj._isErrorsVisible, set: (obj, value) => { obj._isErrorsVisible = value; } }, metadata: _metadata }, __isErrorsVisible_initializers, __isErrorsVisible_extraInitializers);
        __esDecorate(_classThis, null, __progressByFileMapping_decorators, { kind: "accessor", name: "_progressByFileMapping", static: false, private: false, access: { has: obj => "_progressByFileMapping" in obj, get: obj => obj._progressByFileMapping, set: (obj, value) => { obj._progressByFileMapping = value; } }, metadata: _metadata }, __progressByFileMapping_initializers, __progressByFileMapping_extraInitializers);
        __esDecorate(_classThis, null, __canUploadNewFiles_decorators, { kind: "accessor", name: "_canUploadNewFiles", static: false, private: false, access: { has: obj => "_canUploadNewFiles" in obj, get: obj => obj._canUploadNewFiles, set: (obj, value) => { obj._canUploadNewFiles = value; } }, metadata: _metadata }, __canUploadNewFiles_initializers, __canUploadNewFiles_extraInitializers);
        __esDecorate(_classThis, null, _width_decorators, { kind: "accessor", name: "width", static: false, private: false, access: { has: obj => "width" in obj, get: obj => obj.width, set: (obj, value) => { obj.width = value; } }, metadata: _metadata }, _width_initializers, _width_extraInitializers);
        __esDecorate(_classThis, null, _height_decorators, { kind: "accessor", name: "height", static: false, private: false, access: { has: obj => "height" in obj, get: obj => obj.height, set: (obj, value) => { obj.height = value; } }, metadata: _metadata }, _height_initializers, _height_extraInitializers);
        __esDecorate(_classThis, null, _maxFileCount_decorators, { kind: "accessor", name: "maxFileCount", static: false, private: false, access: { has: obj => "maxFileCount" in obj, get: obj => obj.maxFileCount, set: (obj, value) => { obj.maxFileCount = value; } }, metadata: _metadata }, _maxFileCount_initializers, _maxFileCount_extraInitializers);
        __esDecorate(_classThis, null, _maxFileSizePerFile_decorators, { kind: "accessor", name: "maxFileSizePerFile", static: false, private: false, access: { has: obj => "maxFileSizePerFile" in obj, get: obj => obj.maxFileSizePerFile, set: (obj, value) => { obj.maxFileSizePerFile = value; } }, metadata: _metadata }, _maxFileSizePerFile_initializers, _maxFileSizePerFile_extraInitializers);
        __esDecorate(_classThis, null, _maxTotalFileSize_decorators, { kind: "accessor", name: "maxTotalFileSize", static: false, private: false, access: { has: obj => "maxTotalFileSize" in obj, get: obj => obj.maxTotalFileSize, set: (obj, value) => { obj.maxTotalFileSize = value; } }, metadata: _metadata }, _maxTotalFileSize_initializers, _maxTotalFileSize_extraInitializers);
        __esDecorate(_classThis, null, _allowedFileTypes_decorators, { kind: "accessor", name: "allowedFileTypes", static: false, private: false, access: { has: obj => "allowedFileTypes" in obj, get: obj => obj.allowedFileTypes, set: (obj, value) => { obj.allowedFileTypes = value; } }, metadata: _metadata }, _allowedFileTypes_initializers, _allowedFileTypes_extraInitializers);
        __esDecorate(_classThis, null, _displayMode_decorators, { kind: "accessor", name: "displayMode", static: false, private: false, access: { has: obj => "displayMode" in obj, get: obj => obj.displayMode, set: (obj, value) => { obj.displayMode = value; } }, metadata: _metadata }, _displayMode_initializers, _displayMode_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsFileUpload = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.NEW_FILES_ADDED_EVENT = 'sds.upload.file.added';
    _classThis.FILE_PROGRESS_DATA_EVENT = 'sds.upload.file.progress';
    _classThis.FILE_UPLOADED_EVENT = 'sds.upload.file.uploaded';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsFileUpload = _classThis;
})();
export { SdsFileUpload };
